var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var slugify = require('../helpers/slugify');

// Stores
var LanguageStore = require('../stores/language_store');

// Job Area
module.exports = React.createClass({

	// Render
  	render: function(){
  		
  		var self = this;
  		var target = '_blank';
  		
  		if(typeof this.props.env_info.settings.job_links_target != 'undefined' && this.props.env_info.settings.job_links_target === 'same_tab'){
  			target = '_self';
  		}
  		
  		var jobs_url = 'https://jobs.searchsoftware.nl/'+this.props.env;
  		
  		if(typeof self.props.env_info.custom_job_board_domain != 'undefined' && self.props.env_info.custom_job_board_domain != ''){
  			var custom_domain = self.props.env_info.custom_job_board_domain;
  			jobs_url = 'http://'+custom_domain;
  		}
  		
  		var jobs = this.props.other_jobs.map(function(job, index){
  			
  			var job_title = job.title.replace('&amp;', '&');
  			var url_title = (job.url_title != '') ? job.url_title : slugify(job.title);
  			var url = '/'+self.props.env+'/'+job.job_id+'/'+url_title;
  			
  			if(typeof self.props.env_info.custom_job_board_domain != 'undefined' && self.props.env_info.custom_job_board_domain != ''){
	  			var custom_domain = self.props.env_info.custom_job_board_domain;
	  			url = 'http://'+custom_domain+'/job/'+job.job_id+'/'+url_title;
  			}
  			
		    return (<li>
   				<a href={url}>{job_title}</a>
   				<span className="location">{job.address}</span>
   			</li>);
		});
		
   		return (
   			<div className="apply-other-jobs">
   				<h4>{LanguageStore.get('job_ad/title/other_jobs').toUpperCase()}</h4>
   				<ul className="list">
   					{jobs}
   				</ul>
   				
   				<a className="job-board-link" target={target} href={jobs_url}>{LanguageStore.get('job_ad/link/view_all_jobs')}</a>
	  		</div>
	  	);
	}
});

/*<li>
   						<a href="#">Senior Microsoft guy</a>
   						<span className="location">Amsterdam, Netherlands</span>
   					</li>
   					<li>
   						<a href="#">Some other important job</a>
   						<span className="location">Amsterdam, Netherlands</span>
   					</li>
   					<li>
   						<a href="#">Web developer guy</a>
   						<span className="location">Utrecht, Netherlands</span>
   					</li>*/